'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _applyConfigs = require('../utils/apply-configs');

var _applyConfigs2 = _interopRequireDefault(_applyConfigs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	type: 'SCROLL_TO_TOP',
	name: 'Scroll to top',
	allowedSections: ['header', 'footer'],
	disallowedChildren: ['*'],
	category: 'Nav',
	props: [{
		name: 'symbol',
		inputType: 'text',
		label: 'Symbol',
		default: '&uarr;',
		required: true
	}],
	hiddenProps: (0, _applyConfigs2.default)(['htmlclass']).concat({
		label: 'Scroll settings',
		props: [{
			name: 'show',
			inputType: 'slider',
			label: 'When to show the button in px',
			default: 150,
			min: 0,
			max: 500
		}, {
			name: 'top',
			inputType: 'slider',
			label: 'Where to scroll to in px',
			default: 0,
			min: 0,
			max: 500
		}, {
			name: 'duration',
			inputType: 'slider',
			label: 'Scroll duration in milliseconds',
			default: 500,
			min: 0,
			max: 2000
		}]
	})
};